import { CustomerRequestType, IdentifierRequestType, IdentifierType } from "../../../types/types";
import { api } from "../api";

/**
 * identifierOnSaveData - Function that saves on database a new driver identifier   
 * /identifiers  
 * method POST  
 * @async-function
 */
const identifierOnSaveData = async (token: string, model: IdentifierRequestType) => {
    const response = await api.post(
        `/identifiers`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default identifierOnSaveData;